// components/PublicLayout.jsx
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const PublicLayout = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <>
      <Navbar
        isNavOpen={isNavOpen}
        setIsNavOpen={setIsNavOpen}
      />
      <Outlet />
    </>
  );
};

export default PublicLayout;